<template lang="pug">
  div(
    id="app" 
    v-loading="loading"
    element-loading-text="Carregando..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  )
    MenuLataral
    .rotas
      router-view
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import MenuLataral from '@/components/MenuLataral.vue'

export default {
  components: {
    MenuLataral
  },

  created() {
    if (localStorage.getItem('_linkdrive')) {
      this.getUsuarioLogado()
        .catch(err => {
          if (err.response.data.message == 'Token has expired') {
            this.setLoading(false)
            this.$message({
              message: 'Token expirado, refaça o login.',
              type: 'warning'
            })
            localStorage.removeItem('_linkdrive')
            localStorage.removeItem('user')
            setTimeout(() => {
              location.reload()
            }, 2000)
          } if (err.response.data.message == 'Token Signature could not be verified.') {
            this.setLoading(false)
            this.$message.error('Token inválido!')
            localStorage.removeItem('_linkdrive')
            localStorage.removeItem('user')
            setTimeout(() => {
              location.reload()
            }, 2000)
          }
        })
    }
    return false
  },

  computed: {
    ...mapGetters({
      loading: 'globais/loading'
    })
  },

  methods: {
    ...mapActions({
      getUsuarioLogado: 'usuario/getUsuario'
    }),
    ...mapMutations({
      setLoading: 'globais/setLoading'
    })
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
</style>

<style lang="sass">
@import '@/assets/styles/commons.sass';
</style>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: "Poppins", sans-serif;
}
.el-dialog__title {
  color: #ddd !important;
  font-weight: 300 !important;
}
.el-radio-button__inner{
  border-color: #444 !important;
}
.el-divider{
  background-color: #404144 !important;
  .el-divider__text {
    background-color: #161616 !important;
    color: #b7b7b7ad;
    font-weight: 300;
    font-size: 13px;
    font-family: 'Poppins', sans-serif;
  }
}
.el-dialog__body label{
  color: #ffffffad;
  font-weight: 300;
  font-size: 13px;
  font-family: 'Poppins', sans-serif;
}
#app {
  display: flex;
  height: 100%;
  width: 100%;
  background: #151515;

  .el-dialog {
    background-color: #161616;
    border: 1px solid #181818;
  }

  .el-dialog__header{
    border-bottom: 1px solid #353434;
  }

  .rotas {
    display: flex;
    flex: 1;
    max-width: 1420px;
  }
}
</style>
